import { z } from 'zod';
import { Module } from './roles.js';

export const Plan = z.object({
  id: z.string(),
  module: Module,
  name: z.string(),
  renders: z.number().int().nonnegative(),
  hits: z.number().int().nonnegative(),
  cost: z.number().nonnegative(),
  ex_cost_per_hit: z.number().nonnegative().default(0),
  ex_cost_per_render: z.number().nonnegative().default(0),
  started_on: z.string().nullable().optional(),
  ended_on: z.string().nullable().optional(),
  is_active: z.boolean(),
  type: z.string().nullable().optional(),
  scope: z.string().nullable().optional(),
});
export type Plan = z.infer<typeof Plan>;
